import { Dialog, styled } from '@mui/material';

export const CustomDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    padding: 40,
    borderRadius: 10,
    maxWidth: 1500,
  },
});
